// This file was created using Claude AI on 2026-01-06
import { UserText } from '@Constants/UserText';
import {
    Button,
    Card,
    FlexColumn,
    FlexRow,
    type IFrameNotFoundProps,
    LabeledDiv,
} from '@synqo/frontend-component-library';
import { getPrimaryTraceId } from '@utils/traceIdUtils';
import { useCallback, useMemo, useState } from 'react';

export function FrameNotFound(props: IFrameNotFoundProps) {
    const [copySuccess, setCopySuccess] = useState(false);

    const traceId = useMemo(() => {
        const primaryTraceId = getPrimaryTraceId(props.result.messages ?? []);
        return primaryTraceId ? primaryTraceId : UserText.ERROR_TRACE_ID_UNAVAILABLE;
    }, [props.result.messages]);

    const handleCopyTraceId = useCallback(async () => {
        if (traceId !== UserText.ERROR_TRACE_ID_UNAVAILABLE) {
            try {
                await navigator.clipboard.writeText(traceId);
                setCopySuccess(true);
                setTimeout(() => setCopySuccess(false), 2000);
            } catch (err) {
                console.error('Failed to copy trace ID:', err);
            }
        }
    }, [traceId]);

    return (
        <div className="m-5 flex justify-center">
            <div className="w-4/5 max-w-screen-xl">
                <Card name="frame-not-found" border="withoutBorder" gap="md">
                    <FlexColumn gap="md" className="items-center text-center">
                        <h2 className="m-0 text-xl text-(--mantine-color-error-7)">{UserText.NOT_FOUND_TITLE}</h2>
                        <p className="m-0">{UserText.NOT_FOUND_MESSAGE}</p>

                        <LabeledDiv
                            label={UserText.NOT_FOUND_RESOURCE_LABEL}
                            htmlFor="resource-info"
                            className="w-full"
                        >
                            <div className="p-3 bg-(--mantine-color-secondary-3) rounded text-left">
                                <code>
                                    {props.apiResourcePath}/{props.primaryKey}
                                </code>
                            </div>
                        </LabeledDiv>

                        <LabeledDiv label={UserText.ERROR_TRACE_ID_LABEL} htmlFor="trace-id-info" className="w-full">
                            <FlexRow
                                gap="sm"
                                className="items-center p-3 bg-(--mantine-color-secondary-3) rounded border border-(--mantine-color-outline-7)"
                            >
                                <code className="flex-1">{traceId}</code>
                                {traceId !== UserText.ERROR_TRACE_ID_UNAVAILABLE && (
                                    <Button onClick={handleCopyTraceId} size="sm">
                                        {copySuccess ? UserText.ERROR_TRACE_ID_COPIED : UserText.ERROR_TRACE_ID_COPY}
                                    </Button>
                                )}
                            </FlexRow>
                        </LabeledDiv>
                    </FlexColumn>
                </Card>
            </div>
        </div>
    );
}
